import React, { useEffect } from "react";
import Footer from "../components/footer/Footer";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopmentProcess from "../components/developmentProcess/DevelopmentProcess";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { blockchainServices, mainBannerImg } from "../data/blockchainPageData";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import HighValues from "../components/high-values/HighValues";
import RoadMap from "../components/roadMap/RoadMap";
import { IndustryTabsData } from "../data/industriesTabsData";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import FAQ from "../components/Fqas/FAQ";
import ContactSection from "../components/contactSection/ContactSection";
import { WebServicesIndustryTabsItemsData } from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import { AiMlPageData } from "../data/ai-ml-data";

const BlockChainAnalytics = () => {
  const { t } = useTranslation("BlockChainAnalyticsPage");
  const bannerContent = t("pageBanner", { returnObjects: true });
  const servicesContent = t("pageServicesData", { returnObjects: true });
  const processSetpsContent = t("pageProcessStepsData", {
    returnObjects: true,
  });
  const whoWeServeContent = t("pageWhoServeData", { returnObjects: true });
  const whyChooseUsContent = t("pageWhyChooseUsData", { returnObjects: true });
  const highValueContent = t("pageHighValueData", { returnObjects: true });
  const roadMapData = t("pageRoadMapData", { returnObjects: true });
  const coverTheStackData = t("pageCoverTheStack", { returnObjects: true });
  const industriesHeading = t("pageIndustriesHeading", { returnObjects: true });
  const faqData = t("pageFaq", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("blockChainTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Blockchain Development Services Provider Company in USA | Bitsclan</title>
        <meta
          name="description"
          content="Partner with Bitsclan, a top blockchain development company in USA, for dApps, DeFi, NFTs, and smart contracts. Scalable, secure, and tailored blockchain development solutions for your business."
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={bannerContent?.shortHeading}
        mainHeading={bannerContent?.mainHeading}
        description={bannerContent?.description}
      />
      <TrustedPartner />

      <OurServices
        buttonText="Start Your Journey"
        servicesCardsData={blockchainServices?.cardsData}
        shortHeading={blockchainServices?.shortHeading}
        mainHeading={blockchainServices?.mainHeading}
        description={blockchainServices?.description}
      />

      <NewTestimonials
        shortHeading="Our Testimonials"
        mainHeading="Voices of <span>Global</span> Enterprises on Our Blockchain Excellence"
        description="Discover why businesses trust Bitsclan for cutting-edge Blockchain solutions. Read real feedback from clients who achieved success with our services."
      />

      <WhyChooseUs
        heading="Advantage of Partnering With Us"
        greenHeading="The Strategic "
        shortHeading="why Choose Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
        stats={[
          // {
          //   number: "2017",
          //   title: "Delivering Excellence Since"
          // },
          {
            number: "120+",
            title: "Successful Projects Delivered"
          },
          {
            number: "100+",
            title: "Associated Professionals"
          },
        ]}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <CoverTheStack
        whereStart={coverTheStackData?.defaultOpenTab}
        mainHeading={coverTheStackData?.mainHeading}
        subHeading={coverTheStackData?.sectionDescription}
        tabs={coverTheStackData?.blockchaintabs}
        tabItems={coverTheStackData?.blockchaintabItems}
      />

      <SimpleModels content={engagementModelsContent} />

      <PioneeringChange
        tabData={AiMlPageData.industries.tabData}
        // showIndustries={["Healthcare", "Fintech", "E-commerce & Retail", "Real Estate", "Automotive", "Education"]}
        shortHeading="Industries We Serve"
        greenHeading={"Through Blockchain Development"}
        mainHeading={"Redefining Industries "}
        content={
          "Driving innovation & transforming industries with advanced Blockchain expertise & actionable insights."
        }
      />

      <DevelopmentProcess
        heading={processSetpsContent?.mainHeading}
        greenHeading={processSetpsContent?.greenHeading}
        description={processSetpsContent?.sectionDescription}
        processSteps={processSetpsContent?.stepsData}
      />

      <WhoWeServe
        cardContent={whoWeServeContent?.cardsData}
        heading={whoWeServeContent?.mainHeading}
        subHeading={whoWeServeContent?.sectionDescription}
      />

      <WhyChooseBitsclan
        tabs={whyChooseUsContent?.cardsData}
        heading={whyChooseUsContent?.mainHeading}
        subheading={whyChooseUsContent?.sectionDescription}
      />

      <HighValues
        heading={highValueContent?.mainHeading}
        subHeading={highValueContent?.sectionDescription}
        boxContent={highValueContent?.highValueCardData}
        btnLink="#"
        btnText={highValueContent?.buttonText}
      />

      {/* <NewEngagementModels /> */}

      <RoadMap
        heading={roadMapData?.heading}
        description={roadMapData?.description}
        roadMapHeading={roadMapData?.roadMapHeading}
        roadMapsteps={roadMapData?.roadMapsteps}
      />

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="blockchain-development"
      />

      <FAQ
        faqs={faqData?.questionAnswer}
        mainHeading={faqData?.mainHeading}
        subHeading={faqData?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default BlockChainAnalytics;
